// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1s-Pq","requiredAsterisk":"Info_requiredAsterisk__3uIhp"};